import React, { Component, Fragment } from 'react';
import { Query } from 'react-apollo';
import { formatAmount } from 'src/Common/utils';
import Card from './Card';
import QUERY from './query';


export default class Header extends Component {
    render() {
        const { operatorId } = this.props;
        return (
            <Query query={QUERY} variables={{ operatorId }}>
                {({ error, data, loading }) => {
                    const { portalDashboardStats } = data || {};
                    const { simulations, orders, transacted, totalTransacted, conversionRate, weightedMean } = portalDashboardStats || {};
                    return (
                        <div className="header bg-gradient-danger pb-8 pt-5 pt-md-8">
                            <div className="container-fluid">
                                <div className="header-body">
                                    <div className="row">
                                        <div className="col-12 col-md-6 px-xl-6">
                                            <Card
                                                loading={loading}
                                                title="Vendas"
                                                count={orders}
                                                subtitle="Simulações"
                                                subcount={simulations}
                                                subtitle2="Parcela Média"
                                                subcount2={weightedMean}
                                                color="bg-danger"
                                                icon="fas fa-chart-bar"
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 px-xl-6">
                                            <Card
                                                loading={loading}
                                                title="Transacionado"
                                                count={formatAmount(transacted)}
                                                subtitle="Transacionado c/ juros"
                                                subcount={formatAmount(totalTransacted)}
                                                color="bg-yellow"
                                                icon="fas fa-chart-pie"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }}
            </Query>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Dashboard/Header/component.js